"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeActApi = closeActApi;
exports.couponsPageApi = couponsPageApi;
exports.couponslistApi = couponslistApi;
exports.createActsApi = createActsApi;
exports.deleteActApi = deleteActApi;
exports.detailActApi = detailActApi;
exports.getCustomersApi = getCustomersApi;
exports.linkInfoApi = linkInfoApi;
exports.promoSkuListApi = promoSkuListApi;
exports.skuListApi = skuListApi;
exports.statisticsApi = statisticsApi;
exports.updateActApi = updateActApi;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
/**
 *分页查询促销活动管理的产品列表
 */

function couponsPageApi(params) {
  return (0, _request.default)({
    url: "/api/admin/coupons/page",
    method: 'GET',
    params: params
  });
}

/**
 * 数据分析
 */

function statisticsApi(params) {
  return (0, _request.default)({
    url: "/admin/promo/".concat(params.promoId, "/statistics"),
    method: 'GET',
    params: params
  });
}

/**
 * 查询促销活动的链接信息
 */

function linkInfoApi(couponId) {
  return (0, _request.default)({
    url: "/admin/coupons/linkInfo/".concat(couponId),
    method: 'GET'
  });
}

/**
 * 异常关闭促销活动
 */

function closeActApi(params) {
  return (0, _request.default)({
    url: "/admin/promo/".concat(params.promoId, "/close"),
    method: 'PUT',
    params: params
  });
}

/**
 * 查询促销活动详情
 */

function detailActApi(id) {
  return (0, _request.default)({
    url: "/admin/promo/".concat(id),
    method: 'GET'
  });
}

/**
 * 删除促销活动
 */

function deleteActApi(id) {
  return (0, _request.default)({
    url: "/admin/promo/".concat(id),
    method: 'DELETE'
  });
}

/**
 * 创建促销活动
 */

function createActsApi(data) {
  return (0, _request.default)({
    url: "/admin/promo",
    method: 'POST',
    data: data
  });
}

/**
 * 更新促销活动信息
 */

function updateActApi(data) {
  return (0, _request.default)({
    url: "/admin/promo",
    method: 'PUT',
    data: data
  });
}

/**
 * 促销活动列表
 */

function couponslistApi(params) {
  return (0, _request.default)({
    url: "/admin/promo",
    method: 'GET',
    params: params
  });
}

/**
 * SKU分页列表
 */
function skuListApi(data) {
  var params = _objectSpread({}, data);
  if (params.showCateId) {
    params.showCateId = params.showCateId.join(',');
  }
  // return request({
  //     url: `/admin/store/sku/list`,
  //     method: 'GET',
  //     params,
  // });

  return (0, _requestMapi.default)({
    url: '/mapi/product/store/sku/list',
    method: 'GET',
    params: params
  });
}

/**
 * SKU分页列表-促销
 */
function promoSkuListApi(data) {
  var params = _objectSpread({}, data);
  return (0, _request.default)({
    url: "/admin/promo/page",
    method: 'GET',
    params: params
  });
}

/**
 * 查询客户下拉列表
 */

function getCustomersApi(params) {
  return (0, _request.default)({
    url: "/admin/customers/options",
    method: 'GET',
    params: params
  });
}